// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"304":"dd585a4e","559":"2f7a5481","686":"85ef8ba6","801":"3f4d5b49","806":"85d63637"}[chunkId] + ".css";
};